import { useState, useEffect } from 'react';


const noop = () => {};

export function useScrollPosition(callback: (scrollY: number) => void = noop): number {
    const [position, setScrollPosition] = useState<number>(window.pageYOffset);
    useEffect(() => {
        let requestRunning: number | null = null;
        const handleScroll = () => {
            requestRunning = requestRunning || window.requestAnimationFrame(() => {
                callback(window.pageYOffset);
                setScrollPosition(window.pageYOffset);
                requestRunning = null;
            });
        };
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, [callback]);
    return position;
}
